<template>
  <div>
    <div class="innerBox mt-5">
      <h5 class="mb-2">Aging Range By Category</h5>
      <div ref='minMaxAging' style='min-height:500px'></div>
    </div>
    <div class="innerBox mt-5">
      <h5 class="mb-2">Aging Time By Category</h5>
      <aging-time-by-category
        v-if="data"
        :datas="data"
      ></aging-time-by-category>
    </div>
  </div>
</template>

<script>
import * as am4core from '@amcharts/amcharts4/core'
import * as am4charts from '@amcharts/amcharts4/charts'
import kelly from '@amcharts/amcharts4/themes/kelly.js'
import animated from '@amcharts/amcharts4/themes/animated.js'

import agingTimeByCategory from './agingTimeByCategory'

am4core.useTheme(kelly)
am4core.useTheme(animated)

export default {
  props: ['filterUrl'],
  data () {
    return {
      chart: null,
      data: null,
    }
  },
  components : {
    agingTimeByCategory
  },
  mounted () {
    this.createChart()
  },
  watch: {
    filterUrl:{
      handler:'fetchData'
    }
  },
  methods: {
    fetchData(){
      this.$http.get('/api/h1/aging-stock/aging-range?' + this.filterUrl)
      .then((resp)=>{
        this.data = resp.data.data;
      })
      .then(()=>{
        this.loadData()
      })
      .catch((err)=>{
        console.log(err);
      })
    },
    loadData () {
      let length = this.chart.data.length
      var data = this.data

      for (var i = 0 ; i < data.length ; i++) { 
        data[i].min = Math.round(data[i].minimum / 24 * 100) /100
        data[i].min_day = Math.floor(data[i].min)
        data[i].min_hour = Math.floor((data[i].min % 1) * 24)

        data[i].max = Math.round(data[i].maximum / 24 * 100) /100
        data[i].max_day = Math.floor(data[i].max)
        data[i].max_hour = Math.floor((data[i].max % 1) * 24)
      }

      this.chart.addData(data, length)
    },
    createChart () {
      this.chart = am4core.create(this.$refs.minMaxAging, am4charts.XYChart)

      // this.chart.data = data
      let categoryAxis = this.chart.yAxes.push(new am4charts.CategoryAxis())
      categoryAxis.renderer.grid.template.location = 0
      categoryAxis.dataFields.category = 'category'
      categoryAxis.renderer.minGridDistance = 15
      categoryAxis.renderer.grid.template.location = 0.5
      categoryAxis.renderer.grid.template.strokeDasharray = '1,3'
      categoryAxis.renderer.labels.template.horizontalCenter = 'center'
      categoryAxis.renderer.labels.template.location = 0.5
      categoryAxis.title.text = 'Motor Categories'
      categoryAxis.title.fontWeight = 'bold'
      // categoryAxis.renderer.inside = true

      let valueAxis = this.chart.xAxes.push(new am4charts.ValueAxis())
      valueAxis.tooltip.disabled = true
      valueAxis.min = 0
      valueAxis.renderer.ticks.template.disabled = true
      valueAxis.renderer.axisFills.template.disabled = true
      valueAxis.title.text = 'Aging (Hours)'
      valueAxis.title.fontWeight = 'bold'

      let series = this.chart.series.push(new am4charts.ColumnSeries())
      series.dataFields.categoryY = 'category'
      series.dataFields.openValueX = 'minimum'
      series.dataFields.valueX = 'maximum'
      series.tooltipText = 'Minimum Aging : {min_day} Days {min_hour} Hours \n  Maximum Aging : {max_day} Days {max_hour} Hours'
      series.sequencedInterpolation = true
      // series.fillOpacity = 0
      series.strokeOpacity = 1
      series.columns.template.height = 2
      series.tooltip.pointerOrientation = 'horizontal'

      let openBullet = series.bullets.create(am4charts.CircleBullet)
      openBullet.locationX = 1

      let closeBullet = series.bullets.create(am4charts.CircleBullet)

      closeBullet.fill = this.chart.colors.getIndex(4)
      closeBullet.stroke = closeBullet.fill

      this.chart.cursor = new am4charts.XYCursor()
    }
  }
}
</script>
